var _path, _circle, _circle2, _circle3, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceIntroTapPersonal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9951 10.5376L13.9514 10.3298C12.9259 10.1256 11.8691 10.4818 11.1763 11.2651L10.869 11.6126C10.1721 12.4006 10.0892 13.5575 10.6665 14.4368L10.8081 14.6525C11.6924 15.9993 10.8536 17.8062 9.25414 18V18C4.69551 18 1 14.4183 1 10C1 5.58173 4.69551 2 9.25414 2C12.0348 2 14.5012 2.84335 16 4.65303",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 6,
    r: 1,
    fill: "#20242E",
    stroke: "#20242E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 8,
    r: 1,
    fill: "#20242E",
    stroke: "#20242E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 13,
    r: 1,
    fill: "#20242E",
    stroke: "#20242E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8943 18.1773C16.807 17.4895 18.1141 16.7477 18.2704 15.6573C18.4266 14.5668 17.6686 13.5609 16.5773 13.4106C15.4861 13.2602 14.4747 14.0223 14.3185 15.1128C14.1622 16.2032 15.678 16.917 15.8943 18.1773Z",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5503 13.2347C16.1307 13.1758 15.9209 13.1463 15.7588 13.072C15.3702 12.8938 15.1034 12.525 15.0555 12.1002C15.0355 11.9231 15.073 11.7146 15.1481 11.2976L16.6004 3.22784C16.7283 2.51708 17.3951 2.03446 18.1102 2.13497C18.8254 2.23547 19.3333 2.88318 19.2603 3.60168L18.4321 11.7591C18.3893 12.1806 18.3679 12.3914 18.2999 12.5562C18.1367 12.9514 17.7786 13.2322 17.3559 13.2964C17.1796 13.3232 16.9699 13.2937 16.5503 13.2347Z",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIntroTapPersonal);
export default __webpack_public_path__ + "static/media/invoice-intro-tap-personal.f394b92cadceab9307063e609ae75c86.svg";
export { ForwardRef as ReactComponent };